import { EntityState } from '@ngrx/entity';
import { Booking } from '../models/booking';
import { BookingFilter } from '../models/booking.filter';
import { Participant } from '@modules/course/classroom/models/participant'

export const bookingsFeatureKey = 'bookings'

export interface BookingState extends EntityState<Booking> {
  error: any;
  totalCount: number;
  pageIndex: number;
  filter: BookingFilter;
  activeCount: number;
  pendingCount: number;
  upcomingCount: number;
  historyCount: number;
  isGuide: boolean;
  serviceProviderId: string;
  serviceProviderView: boolean;
  isCourseBooked: boolean;
  participants: Participant[]
}
